import type { Rule, Schedule } from "@/domain/types";

/** Keep the configuration for historical alert context after deleting a rule. */
export type ManagedRule = Rule & { deletedAt?: number };
export const isDeletedRule = (rule: Rule) =>
  Boolean((rule as ManagedRule).deletedAt);

export function minuteLabel(minute: number) {
  const hour = Math.floor(minute / 60) % 24;
  return `${hour % 12 || 12}:${String(minute % 60).padStart(2, "0")} ${hour < 12 ? "AM" : "PM"}`;
}
export function scheduleSummary(schedule: Schedule | null, zone: string) {
  if (!schedule) return `Every day, all day · ${zone}`;
  const days = [...schedule.days].sort();
  const label =
    days.length === 7
      ? "Every day"
      : days.join() === "1,2,3,4,5"
        ? "Weekdays"
        : days.join() === "0,6"
          ? "Weekends"
          : days
              .map((d) => ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"][d])
              .join(", ");
  return `${label}, ${schedule.startMinute === schedule.endMinute ? "all day" : `${minuteLabel(schedule.startMinute)} to ${minuteLabel(schedule.endMinute)}`} · ${schedule.timeZone}`;
}
/** Overnight windows continue into the day after the selected start day. */
export function dayWindows(
  schedule: Schedule | null,
  day: number,
): [number, number][] {
  if (!schedule) return [[0, 1440]];
  const { days, startMinute: start, endMinute: end } = schedule;
  if (start === end) return days.includes(day) ? [[0, 1440]] : [];
  if (start < end) return days.includes(day) ? [[start, end]] : [];
  return [
    ...(days.includes((day + 6) % 7) && end > 0
      ? [[0, end] as [number, number]]
      : []),
    ...(days.includes(day) ? [[start, 1440] as [number, number]] : []),
  ];
}
